import { useState } from 'react';

import { useRenderOnlyProductsAndCustomsLang } from './useRenderOnlyProductsAndCustomsLang';

import type { MouseEvent } from 'react';

const COLLAPSE = {
  PRODUCTS: 1,
  CUSTOMS: 2,
} as const;

export function useRenderOnlyProductsAndCustoms() {
  const [collapse, setCollapse] = useState({ products: true, customs: true });

  const lang = useRenderOnlyProductsAndCustomsLang();

  const handleClickCollapse = (e: MouseEvent<HTMLButtonElement>) => {
    const listId = Number(e.currentTarget.dataset.listId);
    if (listId === COLLAPSE.PRODUCTS) {
      setCollapse(ps => ({ ...ps, products: !ps.products }));
    } else if (listId === COLLAPSE.CUSTOMS) {
      setCollapse(ps => ({ ...ps, customs: !ps.customs }));
    }
  };

  return {
    lang,
    dataListIdToProducts: COLLAPSE.PRODUCTS,
    dataListIdToCustoms: COLLAPSE.CUSTOMS,
    collapse,
    handleClickCollapse,
  };
}
